import React from 'react';

import { ModalHeader } from '@lightspeed/cirrus-modal';
import has from 'lodash/has';
import PropTypes from 'prop-types';

import { TransactionState } from './ManualPaymentTypes';

const ManualPaymentHeader = ({ selectedTerminal, transactionState, onClose }) => {
  let title = 'No Title';

  switch (transactionState) {
    case TransactionState.WAITING_TO_START:
      title = 'Manual Credit/Debit';
      break;

    case TransactionState.ENTER_CARD_DETAILS:
      title = 'Enter Card Information';
      break;

    case TransactionState.FAILED:
      title = 'Manual Credit/Debit Transaction Failed';
      break;

    default:
      title = has(selectedTerminal, 'model')
        ? selectedTerminal.model.get('name')
        : 'Manual Credit/Debit';
      break;
  }

  return (
    <ModalHeader showCloseButton={false} onCloseClicked={onClose}>
      <div>{title}</div>
    </ModalHeader>
  );
};

ManualPaymentHeader.propTypes = {
  selectedTerminal: PropTypes.shape(PropTypes.any.object),
  transactionState: PropTypes.string,
  onClose: PropTypes.func,
};

ManualPaymentHeader.defaultProps = {
  selectedTerminal: null,
  transactionState: TransactionState.WAITING_TO_START,
  onClose: () => {},
};

export default ManualPaymentHeader;
